export default __webpack_public_path__ + "static/media/SconeMixProductInfo3.725a87c8.jpg";